'use strict';

var core = require('@capacitor/core');

const EdgeToEdge = core.registerPlugin('EdgeToEdge', {});

exports.EdgeToEdge = EdgeToEdge;
//# sourceMappingURL=plugin.cjs.js.map
